var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "pt-cascader-menu" }, _vm._l(_vm.nodes, function (item) {
    return _c('pt-cascader-node', { key: item.value, attrs: { "type": _vm.checkedType, "tooltip": item.label, "checked": _vm.isChecked(item.value), "isLeaf": !item.children || item.children.length === 0, "expended": _vm.expandValue === item.value }, on: { "change": function change($event) {
          return _vm.handleNodeChange(item.value, $event);
        }, "expand": function expand($event) {
          return _vm.$emit('expand', item, $event);
        } }, scopedSlots: _vm._u([{ key: "icon", fn: function fn() {
          return [_vm._t("icon", null, null, item)];
        }, proxy: true }], null, true) }, [_vm._t("default", function () {
      return [_vm._v(_vm._s(item.label))];
    }, null, item)], 2);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };